import { render, staticRenderFns } from "./CardiolineRichiesteListComponent.vue?vue&type=template&id=2323904d&scoped=true"
import script from "./CardiolineRichiesteListComponent.vue?vue&type=script&lang=js"
export * from "./CardiolineRichiesteListComponent.vue?vue&type=script&lang=js"
import style0 from "./CardiolineRichiesteListComponent.vue?vue&type=style&index=0&id=2323904d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323904d",
  null
  
)

export default component.exports